import { render, staticRenderFns } from "./ImageMessage.vue?vue&type=template&id=012b04a4&scoped=true"
import script from "./ImageMessage.vue?vue&type=script&lang=js"
export * from "./ImageMessage.vue?vue&type=script&lang=js"
import style0 from "./ImageMessage.vue?vue&type=style&index=0&id=012b04a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012b04a4",
  null
  
)

export default component.exports